import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Table, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";

function TableWidget(props) {
  const [dataSource, setDataSource] = useState([]);
  const { dataList, onUpdateAction, onDeleteAction } = props;

  useEffect(() => {
    if (dataList !== undefined) {
      setDataSource([...dataList.map((info) => ({ ...info, key: info.id }))]);
    }
  }, [dataList]);
  if (dataList === undefined) return <div />;

  const columns = [
    { title: "Name", dataIndex: "name", render: (t) => <span style={{ fontWeight: 600 }}>{t}</span> },
    {
      title: "Base unit?",
      dataIndex: "is_base",
      align: "center",
      render: (t) => <Tag color={t === "1" ? "blue" : "default"}>{t === "1" ? "Base" : "Derived"}</Tag>,
    },
    {
      title: "Converts to",
      key: "converts_to",
      align: "center",
      render: (_, record) =>
        record.is_base === "1" ? "—" : `${Number(record.factor || 0)} × ${record.base_unit_name || "?"}`,
    },
    {
      title: "Weight unit?",
      dataIndex: "is_weight",
      align: "center",
      render: (t) => (t ? <Tag color="green">Yes</Tag> : <Tag color="default">No</Tag>),
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (t) => <Tag color={t === "1" ? "green" : "default"}>{t === "1" ? "Active" : "Hidden"}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => (
        <div>
          <a style={{ color: "var(--blueColor)", marginLeft: 12 }} onClick={() => onUpdateAction(record)}>
            Edit
          </a>
          <a
            style={{ color: "var(--redColor)", marginLeft: 16 }}
            onClick={async () => {
              const res = await showConfirmDlgWidget({
                title: "Delete Confirmation",
                content: `Delete the "${record.name}" unit?`,
              });
              if (res == false) return;
              onDeleteAction(record);
            }}
          >
            Delete
          </a>
        </div>
      ),
    },
  ];

  return (
    <div className="list-table">
      <Table pagination={false} columns={columns} dataSource={dataSource} />
    </div>
  );
}

export default withRouter(TableWidget);
